module.exports = __webpack_public_path__ + "static/media/email.d0f83c14.png";